export class DirectMessageTemplateQueryParameters {
  departmentId?: string;
  employeeId?: string;
  id?: string;
  constructor(obj?: any) {
    if (obj) Object.assign(this, obj);
  }
}
